import Vue from 'vue'
import { create } from 'vue-modal-dialogs'

import Alert from './common/Alert'
import Confirm from './common/Confirm'
import NewHero from './cms/NewHero'
import UpdateHero from './cms/UpdateHero'
import UpdateScreeningPoster from './cms/UpdateScreeningPoster'
import UpdateArticleImage from './cms/UpdateArticleImage'
import UpdateFacilityCover from './cms/UpdateFacilityCover'
import NewGalleryImage from './cms/NewGalleryImage'
import EditGalleryImage from './cms/EditGalleryImage'
import NewFacilityPricing from './facility/NewPricing'
import EditFacilityPricing from './facility/EditPricing'
import NewFacilityExtra from './facility/NewExtra'
import EditFacilityExtra from './facility/EditExtra'
import MarkBookingAsPaid from './booking/MarkAsPaid'
import CaptureDepositForfeiture from './deposit/Forfeit'
import DisplayDepositForfeiture from './deposit/Forfeiture'
import CaptureDepositReimbursement from './deposit/Reimburse'
import MarkAdditionalBillingAsPaid from './booking/additional-billing/MarkAsPaid'

Vue.prototype.$alert = create(Alert, 'title', 'message')
Vue.prototype.$confirm = create(Confirm)

export let newHero = create(NewHero)
export let updateHero = create(UpdateHero, 'heroId')
export let updateScreeningPoster = create(UpdateScreeningPoster, 'screeningId')
export let updateArticleImage = create(UpdateArticleImage, 'articleId')
export let updateFacilityCover = create(UpdateFacilityCover, 'facilityId')
export let newGalleryImage = create(NewGalleryImage, 'galleryId')
export let editGalleryImage = create(EditGalleryImage, 'imageId')
export let newFacilityPricing = create(NewFacilityPricing, 'facilityId')
export let editFacilityPricing = create(EditFacilityPricing, 'payload')
export let newFacilityExtra = create(NewFacilityExtra, 'facilityId')
export let editFacilityExtra = create(EditFacilityExtra, 'payload')
export let markBookingAsPaid = create(MarkBookingAsPaid, 'payload')
export let captureDepositForfeiture = create(CaptureDepositForfeiture, 'payload')
export let displayDepositForfeiture = create(DisplayDepositForfeiture, 'payload')
export let captureDepositReimbursement = create(CaptureDepositReimbursement, 'payload')
export let markAdditionalBillingAsPaid = create(MarkAdditionalBillingAsPaid, 'payload')